<template>
  <div class="configurator-form-radio || flex flex-wrap">
    <div
      v-for="(option, index) in options"
      :key="`${id}-${index}`"
      class="configurator-form-radio__item
        space-mb-3
        space-mb-0--m
        space-mx-2--s">
      <input
        :id="`${id}-${index}`"
        v-model="model"
        type="radio"
        :name="id"
        :value="option.value"
        class="configurator-form-radio__input">
      <label
        :for="`${id}-${index}`"
        class="configurator-form-radio__label
          card type-subtitle
          type-weight-700
          type-align-center
          space-px-3
          space-py-3
          space-py-5--s
          flex
          flex-column--s
          justify-center--s
          align-center">
        <div v-if="$scopedSlots.icon">
          <slot name="icon" :option="option" />
        </div>
        <span>{{ option.label[$i18n.locale] || option.label }}</span>
      </label>
    </div>
  </div>
</template>
<script>
  /**
   * FormRadio component used in both of the configurators
   * @displayName FormRadio
   */
  import { nanoid } from 'nanoid';

  export default {
    props: {
      /**
       * The different options available
       * @type {Array}
       */
      options: {
        type: Array,
        required: true,
        default: () => [],
      },
      /**
       * The selected value
       * @type {String}
       */
      // eslint-disable-next-line vue/require-prop-types
      value: {
        type: String,
        required: true,
        default: () => '',
      },
    },
    data() {
      return {
        id: nanoid(),
      };
    },
    computed: {
      model: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit('input', value);
        },
      },
    },
  };
</script>
<style lang="scss">
  .configurator-form-radio__item {
    width: 100%;
    min-width: calc(100% / 9);
    border: 1px solid transparent;

    @media #{md('m')} {
      flex: 1;
      min-height: 190px;
    }
  }

  .configurator-form-radio__label {
    height: 100%;

    span {
      white-space: nowrap;
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 2px solid c('green');
      border-radius: 5px;
      opacity: 0;
      transition: opacity 0.2s ease-out;
    }
  }
  .configurator-form-radio__input {
    z-index: l(default);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    cursor: pointer;
    opacity: 0;

    &:focus ~ .configurator-form-radio__label::before {
      opacity: 0.5;
    }

    &:hover ~ .configurator-form-radio__label::before,
    &:checked ~ .configurator-form-radio__label::before {
      opacity: 1;
    }
  }
</style>
